var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteitem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.38,
    y: 5.54,
    width: 14.49,
    height: 17.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.16,
    y1: 5.54,
    x2: 22.09,
    y2: 5.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.21,
    y1: 9.56,
    x2: 9.21,
    y2: 19.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.04,
    y1: 9.56,
    x2: 14.04,
    y2: 19.06
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.45,5.22a2.72,2.72,0,0,1,0-.28,4.19,4.19,0,1,1,8.37,0c0,.09,0,.19,0,.29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteitem);
export default __webpack_public_path__ + "static/media/deleteitem.0440576b7f0bced44750a6451e0da57d.svg";
export { ForwardRef as ReactComponent };